import { useMemo, useRef } from 'react';
export function useSingleton(creator) {
  var ref = useRef(null);
  return useMemo(function () {
    if (ref.current) {
      return ref.current;
    }

    return ref.current = creator();
  }, []);
}